import React from 'react';

import Wrap from './styled/Wrap';

const Item: React.FC<{
  value: string;
  unit: string;
  align?: string;
  bold?: boolean;
  color?: string;
}> = props => (
  <Wrap {...props}>
    <>
      <span className="amount">{props.value}</span>
      <span>{props.unit}</span>
    </>
  </Wrap>
);

export default Item;
